import { ReactNode } from 'react';
import { pdsTheme } from './theme';
import { GetBrandTheme } from '@leadflow/shared/theme/GetBrandTheme';

const ThemeProviderWrapper = ({ children }: { children: ReactNode }) => {
  return <GetBrandTheme brandTheme={pdsTheme}>{children}</GetBrandTheme>;
};

export default ThemeProviderWrapper;
